package xyz.malefic.guptare.client.styles

import org.jetbrains.compose.web.css.px

object AppRadius {
    val Sm = 2.px // 0.125 rem
    val Default = 4.px // 0.25 rem  ← primary shape unit (buttons, inputs)
    val Md = 6.px // 0.375 rem
    val Lg = 8.px // 0.5 rem   ← cards
    val Xl = 12.px // 0.75 rem  ← floating widgets, search bar
    val Full = 9999.px // pills / chips
}
